/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { LoyaltyProgramSummaryV2Dto } from './loyaltyProgramSummaryV2Dto';
import { PlaceInformationDto } from './placeInformationDto';


export interface LocationV2Dto { 
    id?: number;
    displayName?: string;
    address1?: string;
    address2?: string;
    city?: string;
    postalCode?: string;
    county?: string;
    country?: string;
    lat?: number;
    lng?: number;
    office?: boolean;
    hq?: boolean;
    active?: boolean;
    placeInformation?: PlaceInformationDto;
    distance?: number;
    loyaltyProgram?: LoyaltyProgramSummaryV2Dto;
}

